import { createSlice, current } from '@reduxjs/toolkit';
import { captureException } from '@sentry/react';
import { isShallowIdentical } from 'utils/isShallowIdentical';

import type ISkyttaTranslations from './ISkyttaTranslations';
import { fetchTranslations } from './translations.thunks';

type TranslationsState = {
  translations: ISkyttaTranslations | null;
};

const initialState: TranslationsState = {
  translations: null
};

export const { reducer: translationsReducer } = createSlice({
  name: 'translations',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTranslations.fulfilled, (state, { payload: translations }) => {
        if (isShallowIdentical(current(state).translations, translations)) {
          return;
        }

        return {
          ...state,
          translations
        };
      })
      .addCase(fetchTranslations.rejected, (state, action) => {
        const error = new Error();
        error.name = 'Failed to fetch translations data';
        error.message = action.error.message || '';

        captureException(error, (scope) => {
          scope.setExtra('state', state);
          scope.setExtra('action', action);
          return scope;
        });
      });
  }
});
